// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__Vq-ND","colMaxWidth":"Table_colMaxWidth__1J53t"};